/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navaccount1Inputs */

const en_navaccount1 = /** @type {(inputs: Navaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const pt_navaccount1 = /** @type {(inputs: Navaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Navaccount1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const navaccount1 = /** @type {((inputs?: Navaccount1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navaccount1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_navaccount1(inputs)
	return pt_navaccount1(inputs)
});
export { navaccount1 as "navAccount" }